export const REPROCESS_ODOMETER_HOURS_REQUEST = "REPROCESS_ODOMETER_HOURS_REQUEST";
export const REPROCESS_ODOMETER_HOURS_RESULT = "REPROCESS_ODOMETER_HOURS_RESULT";
export const REPROCESS_ODOMETER_HOURS_OPEN_MODAL = "REPROCESS_ODOMETER_HOURS_OPEN_MODAL";
export const REPROCESS_ODOMETER_HOURS_CLOSE_MODAL = "REPROCESS_ODOMETER_HOURS_CLOSE_MODAL";
export const REPROCESS_ODOMETER_HOURS_GET_DEVICE_REQUEST = "REPROCESS_ODOMETER_HOURS_GET_DEVICE_REQUEST";
export const REPROCESS_ODOMETER_HOURS_GET_DEVICE_RESULT = "REPROCESS_ODOMETER_HOURS_GET_DEVICE_RESULT";

export const REPROCESS_ODOMETER_HOURS_SET_DEVICE = "REPROCESS_ODOMETER_HOURS_SET_DEVICE";

